import React, { useEffect } from 'react'
import { useState } from 'react';
import { isImage, toTime } from '../utils'
import { deleteUserTalentDocument, updateCourseDocumentFavorite, updateCourseDocumentRefereeVisible } from '../utils/Network';
import Modal from 'react-modal';
import AddToCourseForm from './forms/AddToCourseForm';

export default function UserTalentDocument({ item,usertalent, openModal,...props}) {

    const [duration, setDuration] = useState(null);
    const [addToCourseModalIsOpen, setAddToCourseModalIsOpen] = useState(false);
    const [courseDocument, setCourseDocument] = useState(false);
    const [referee_visible, setRefereeVisible] = useState(false)
    const [favorite, setFavorite] = useState(false)

    useEffect(() => {
        if (item)
            {
                if(item.coursedocuments.length>0){
                    setCourseDocument(item.coursedocuments[0])
                    setRefereeVisible(item.coursedocuments[0].referee_visible)
                    setFavorite(item.coursedocuments[0].favorite)
                }
            }
    }, [])
    
    const handleVideoMounted = element => {
        if (element !== null && element) {
            element.currentTime = 5;
            if (!isNaN(element.duration))
                setDuration(element.duration)
        }
    };

    const handleDelete=()=>{
        if(window.confirm('are you sure ?')){
            deleteUserTalentDocument(item).then((data) => {
                if(props.callback) props.callback()
              });
        }
        
    }

    const updateRefereeVisible = () => {
        updateCourseDocumentRefereeVisible(courseDocument.id, !referee_visible).then(data => {
            setRefereeVisible(!referee_visible)
        })
    }

    const updateIsFavorited = () => {
        updateCourseDocumentFavorite(courseDocument.id, !favorite).then(data => {
            setFavorite(!favorite)
        })
    }


    const closeModal=()=>{
        setAddToCourseModalIsOpen(false)
    }

    

    
    
    return (
        <div key={item.id} className="row">
            <div  className="col-md-8 col-sm-8">
                <div className="document" onClick={() => { openModal(item) }} >
                    {isImage(item.file) &&
                        <img src={item.file} alt="" />

                    }
                    {item.url!=null && item.url?.includes('firebasestorage') &&
                        <video width="100%" ref={handleVideoMounted} >
                            <source src={item.url} type="video/mp4" />
                        </video>
                    }
                    <span className="infoicon">
                        <i className="fa fa-play"></i>
                    </span>

                </div>
                
                </div>
                <div className="col-md-4">
                <div className="btn-group mb-5">
                    <button type="button" onClick={(e) => { handleDelete()  }} className="btn btn-primary btn-sm">
                        <i className="fa fa-trash"></i>
                    </button>
                    <button type="button ml-10" onClick={(e) => { setAddToCourseModalIsOpen(true)  }} className="btn btn-primary btn-sm">
                        <i className="fa fa-trophy color-gold"></i>
                    </button>
                    <button title={`${referee_visible ? "Visible to referee" : "Not visible to referee"}`} type="button ml-10" onClick={(e) => { updateRefereeVisible() }} className="btn btn-primary btn-sm">
                        <i className={`fa fa-gavel ${referee_visible ? "color-success" : ""}`}></i>
                    </button>
                    {/* <button title={`${favorite ? "Favorited" : "Not favorited"}`} type="button ml-10" onClick={(e) => { updateIsFavorited() }} className="btn btn-primary btn-sm">
                        <i className={`fa fa-heart ${favorite ? "color-liked" : ""}`}></i>
                    </button> */}
                    

                </div>
                <p className="date">{item.created_at.split('T')[0]} &nbsp; - &nbsp; {toTime(Math.round(duration))}</p>
                </div>
                <Modal
                closeTimeoutMS={500}
                isOpen={addToCourseModalIsOpen}
                onRequestClose={closeModal}
                className="Modal"
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">Add To Contest</h4>
                    </div>
                    <div class="modal-body text-center">
                        <AddToCourseForm userdocument={item && item.id} usertalent={usertalent} callback={()=>{ setAddToCourseModalIsOpen(false);  }} />
                    </div>

                </div>
            </Modal>
            </div>
    )
}
